<div id="layout-wrapper" class="min-h-screen bg-gray-50">
    <!-- Top Bar -->
    <app-topbar *ngIf="!isFirstTimeSetupFlow" (mobileMenuButtonClicked)="onToggleMobileMenu()"></app-topbar>

    <!-- Side Bar -->
    <app-sidebar *ngIf="!isFirstTimeSetupFlow"></app-sidebar>
    
    <!-- Main -->
    <div class="main-content transition-all duration-300 flex flex-col min-h-screen"
         [ngClass]="{
           'ml-0': isFirstTimeSetupFlow,
           'ml-0 md:ml-64': !isFirstTimeSetupFlow && (sidebarSize === 'lg' || sidebarSize === null),
           'ml-0 md:ml-20': !isFirstTimeSetupFlow && sidebarSize === 'sm',
           'ml-0 md:ml-16': !isFirstTimeSetupFlow && sidebarSize === 'sm-hover'
        }">
        <div class="page-content flex-1">
            <div class="container-fluid" [ngClass]="{ 'overflow-x-hidden': isFirstTimeSetupFlow }">
                <router-outlet></router-outlet>
            </div>
        </div>

        <!-- Footer -->
        <app-footer *ngIf="!isFirstTimeSetupFlow"></app-footer>
    </div>
</div>

<!--
<div class="fixed bottom-6 right-6">
  <button class="btn btn-secondary"
            type="button"
            (click)="onShowFeedback()">
        Support
    </button>
</div>
-->
